import { useEffect, useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "../store/cart";

const navLinks = [
  { to: "/shop", label: "SHOP" },
  { to: "/shop?category=tees", label: "TEES" },
  { to: "/shop?category=hoodies", label: "HOODIES" },
  { to: "/shop?category=caps", label: "CAPS" },
  { to: "/manifesto", label: "MANIFESTO" },
  { to: "/order-lookup", label: "TRACK" },
];

export default function Header() {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = useState(false);
  const [scrolled, setScrolled] = useState(false);
  const loc = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const on = () => setScrolled(window.scrollY > 30);
    on();
    window.addEventListener("scroll", on, { passive: true });
    return () => window.removeEventListener("scroll", on);
  }, []);

  return (
    <>
      {/* Top announcement bar */}
      <div data-testid="announcement-bar" className="bg-blood text-bone text-[10px] sm:text-[11px] tracking-[0.3em] font-mono uppercase py-2 text-center px-4 truncate">
        FREE SHIPPING OVER $100 ★ DROP 002 LOADING ★ STAY DANGEROUS ★ 永遠の遺産
      </div>

      <header
        data-testid="site-header"
        className={`sticky top-0 z-40 border-b border-white/20 transition-all duration-200 ${
          scrolled ? "bg-ink/90 backdrop-blur-md" : "bg-ink"
        }`}
      >
        <div className="mx-auto flex max-w-7xl items-center justify-between px-4 py-4 sm:px-6 lg:px-8">
          <button
            data-testid="mobile-menu-button"
            className="lg:hidden text-bone"
            onClick={() => setMobileOpen((v) => !v)}
            aria-label="menu"
          >
            {mobileOpen ? <X size={22} /> : <Menu size={22} />}
          </button>

          <Link
            to="/"
            data-testid="logo-link"
            className="font-anton text-2xl sm:text-3xl tracking-tighter uppercase text-bone hover:text-blood transition-colors"
          >
            TOXIC<span className="text-blood">/</span>STREET
          </Link>

          <nav className="hidden lg:flex items-center gap-7">
            {navLinks.map((l) => (
              <Link
                key={l.to}
                to={l.to}
                data-testid={`nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                className={`text-xs tracking-[0.25em] uppercase font-mono transition-colors ${
                  loc.pathname + loc.search === l.to
                    ? "text-blood"
                    : "text-bone hover:text-blood"
                }`}
              >
                {l.label}
              </Link>
            ))}
          </nav>

          <div className="flex items-center gap-4">
            <button
              data-testid="open-cart-button"
              onClick={() => setOpen(true)}
              className="relative text-bone hover:text-blood transition-colors"
              aria-label="cart"
            >
              <ShoppingBag size={22} />
              {count > 0 && (
                <span
                  data-testid="cart-count-badge"
                  className="absolute -top-2 -right-2 min-w-[18px] h-[18px] bg-blood text-bone text-[10px] font-mono leading-[18px] text-center px-1"
                >
                  {count}
                </span>
              )}
            </button>
          </div>
        </div>

        {mobileOpen && (
          <div data-testid="mobile-menu" className="lg:hidden border-t border-white/20 bg-ink">
            {navLinks.map((l) => (
              <button
                key={l.to}
                data-testid={`mobile-nav-${l.label.toLowerCase().replace(/\s/g, "-")}`}
                onClick={() => {
                  navigate(l.to);
                  setMobileOpen(false);
                }}
                className="block w-full text-left px-6 py-4 border-b border-white/10 text-bone hover:bg-blood/20 text-sm tracking-[0.2em] uppercase font-mono"
              >
                {l.label}
              </button>
            ))}
          </div>
        )}
      </header>
    </>
  );
}
